import { TSavedLaneSchema } from '../schema'
import { IRateTypes } from '../types'

/**
 * Returns a SavedLaneSchema rateType value bassed off LaneAlert rateType
 *
 * @example getSavedLaneSchemaRateType('all_in') // IRateTypes.totalAllIn
 */
export const getSavedLaneSchemaRateType = (
  rateType: '' | 'all_in' | 'rpm' | null
): TSavedLaneSchema['rateType'] => {
  switch (rateType) {
    case 'all_in':
      return IRateTypes.totalAllIn
    case 'rpm':
      return IRateTypes.ratePerMile
    default:
      return IRateTypes.anyRate
  }
}
